import {
  FormControl as MuiFormControl,
  type FormControlProps as MuiFormControlProps,
  FormHelperText as MuiFormHelperText,
  type FormHelperTextProps as MuiFormHelperTextProps,
  InputLabel as MuiInputLabel,
  type InputLabelProps as MuiInputLabelProps,
  Select as MuiSelect,
  type SelectChangeEvent,
  type SelectProps as MuiSelectProps
} from "@mui/material";

export type SelectProps<T = unknown> = MuiSelectProps<T>;
export type { SelectChangeEvent };
export type FormControlProps = MuiFormControlProps;
export type InputLabelProps = MuiInputLabelProps;
export type FormHelperTextProps = MuiFormHelperTextProps;

export const Select = MuiSelect;
export const FormControl = MuiFormControl;
export const InputLabel = MuiInputLabel;
export const FormHelperText = MuiFormHelperText;
